import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

function SvgComponent(props) {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={203} height={32} viewBox="0 0 203 32" fill="none" {...props}>
            <Path
                d="M177.494 31.4468V0.553212H203V8.17023H186.633V12.5107H198.749V19.1915H186.633V23.7447H203V31.4468H177.494Z"
                fill={ds.colorValue.icon.primary}
            />
            <Path
                d="M141.293 31.4468V0.553212H155.492C166.247 0.553212 174.026 6.42555 174.026 15.8724C174.026 25.4894 166.119 31.4468 155.619 31.4468H141.293ZM154.132 23.7447C159.785 23.7447 163.866 21.7447 163.866 16C163.866 10.3404 160.126 8.25534 154.089 8.25534H150.603V23.7447H154.132Z"
                fill={ds.colorValue.icon.primary}
            />
            <Path
                d="M102 31.4468L114.838 0.553212H126.401L139.197 31.4468H129.377L127.039 25.6596H113.946L111.693 31.4468H102ZM116.496 18.5532H124.488L120.45 8.51066L116.496 18.5532Z"
                fill={ds.colorValue.icon.primary}
            />
            <Path
                d="M89.6913 32C79.1912 32 70.5616 25.5745 70.5616 16.1702C70.5616 7.31915 78.256 0 90.0314 0C93.6023 0 97.5557 0.765958 100.829 2.59574L101.084 12.2979C98.0234 9.53191 94.41 7.95745 90.584 7.95745C85.3978 7.95745 80.7216 11.0213 80.7216 15.9574C80.7216 20.9362 85.2702 24.0426 90.669 24.0426C94.495 24.0426 98.5335 22.4255 101.637 19.617L100.489 29.1915C98.1084 30.9362 94.1124 32 89.6913 32Z"
                fill={ds.colorValue.icon.primary}
            />
            <Path
                d="M39.2931 31.4468V0.553212H54.4269C64.7144 0.553212 68.2853 5.61704 68.2853 10.3404C68.2853 14.6809 64.8419 18.5532 59.4006 20.0426L69.6881 31.4468H58.3378L49.3256 20.6383H48.6029V31.4468H39.2931ZM53.9167 13.9575C56.5099 13.9575 58.4654 12.7234 58.4654 10.8511C58.4654 8.85109 56.5949 7.70215 53.9167 7.70215H48.6029V13.9575H53.9167Z"
                fill={ds.colorValue.icon.primary}
            />
            <Path
                d="M0 31.4468L12.8382 0.553212H24.401L37.1967 31.4468H27.3768L25.0387 25.6596H11.9454L9.69239 31.4468H0ZM14.4961 18.5532H22.488L18.4496 8.51066L14.4961 18.5532Z"
                fill={ds.colorValue.icon.primary}
            />
        </Svg>
    );
}

export default SvgComponent;
